import { WebLayout } from 'components/Layout';
import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { Button } from 'components/Elements';
import { InputField, TextAreaField } from 'components/Form';

export const ContactUs = () => {
  return (
    <WebLayout>
      <div className="bg-[#26C4FF] p-6 md:p-12 mt-8 mb-8 md:px-40 text-white">
        <div className="text-4xl md:text-7xl text-center font-black mb-4">Contact Us</div>
        <p className="text-center mb-8 text-lg md:text-xl">
          Have any questions? Reach out to us anytime.
        </p>
      </div>
      <div class="p-4 mx-auto max-w-xl bg-white font-[sans-serif]">
        <h1 class="text-2xl text-gray-800 font-bold text-center">Send us a message</h1>
        <form class="mt-8 space-y-4">
          <input
            type="text"
            placeholder="Name"
            class="w-full py-2.5 px-4 text-gray-800 bg-gray-100 border focus:border-black focus:bg-transparent text-sm outline-none transition-all"
          />
          <input
            type="email"
            placeholder="Email"
            class="w-full py-2.5 px-4 text-gray-800 bg-gray-100 border focus:border-black focus:bg-transparent text-sm outline-none transition-all"
          />
          <input
            type="text"
            placeholder="Subject"
            class="w-full py-2.5 px-4 text-gray-800 bg-gray-100 border focus:border-black focus:bg-transparent text-sm outline-none transition-all"
          />
          <textarea
            placeholder="Message"
            rows="4"
            class="w-full px-4 text-gray-800 bg-gray-100 border focus:border-black focus:bg-transparent text-sm pt-3 outline-none transition-all"
          ></textarea>
          <button
            type="button"
            class="text-white bg-black hover:bg-gray-900 tracking-wide text-sm px-4 py-2.5 w-full outline-none"
          >
            Send
          </button>
        </form>
      </div>
    </WebLayout>
  );
};
